import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tokenDisplay"]
  declare readonly tokenDisplayTarget: HTMLElement

  showToken(event: CustomEvent) {
    const token = event.detail.token
    if (token) {
      this.tokenDisplayTarget.textContent = token
      this.tokenDisplayTarget.classList.remove("hidden")
    } else {
      this.tokenDisplayTarget.textContent = "No token received"
      this.tokenDisplayTarget.classList.remove("hidden")
    }
  }
}
